import { render, staticRenderFns } from "./customform.vue?vue&type=template&id=20de8e80&"
import script from "./customform.vue?vue&type=script&lang=js&"
export * from "./customform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports